import React, { useState } from 'react';
import { Card, CardHeader, CardBody, Button, Offcanvas } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import Icon from '@mdi/react';
import {
  mdiCalendar,
  mdiChevronRight,
  mdiChevronLeft,
  mdiCircleMedium,
} from '@mdi/js';
import './PunchInWidget.css';
import ManualPunchIn from './ManualPunchIn';

function PunchInWidget() {
  const navigate = useNavigate();
  const [punchInOffcanvas, setPunchInOffcanvas] = useState(false);
  const togglePunchInOffcanvas = () => {
    setPunchInOffcanvas(!punchInOffcanvas);
  };

  return (
    <Card className="punch-in-widget-container">
      <CardHeader className="punch-in-widget-header">
        <div className="d-flex flex-row align-items-center justify-content-between gap-2">
          <div className="d-flex flex-row align-items-center gap-2">
            <div className="punch-in-widget-header-icon">
              <Icon path={mdiCalendar} size={0.7} />
            </div>
            <div>
              <span className="h6">Today - 13 Mar 2025</span>
            </div>
          </div>

          <div
            className="d-flex align-items-center justify-content-center gap-2 py-1 pe-1"
            style={{
              border: '1px solid lightgrey',
              borderRadius: '13px',
            }}
          >
            <Icon path={mdiCircleMedium} size={0.7} color="red" />
            <span>Late/Missed</span>
          </div>
        </div>
      </CardHeader>
      <CardBody
        className="punch-in-widget-card-body"
        onClick={() => navigate('/timesheet')}
      >
        <div className="mb-3 w-100">
          <div>
            <span className="text-muted">Shift Time</span>
          </div>
          <div className="d-flex flex-row align-items-center justify-content-between w-100">
            <div className="w-50">
              <span className="h5">10:00 - 19:00</span>
            </div>
            <div className="w-50">
              <Button
                className="punch-in-btn w-100"
                onClick={() => togglePunchInOffcanvas()}
              >
                Punch-In
              </Button>
            </div>
          </div>
        </div>
        <div className="d-flex flex-row align-items-center justify-content-between w-100 mb-3">
          <div>
            <div>
              <span className="text-muted">Punch-In</span>
            </div>
            <div>
              <span className="text-muted">--:--</span>
            </div>
          </div>
          <div>
            <div>
              <span className="text-muted">Punch-Out</span>
            </div>
            <div>
              <span className="text-muted">--:--</span>
            </div>
          </div>
          <div>
            <div>
              <span className="text-muted">Working Hours</span>
            </div>
            <div>
              <span className="text-muted">--:--</span>
            </div>
          </div>
        </div>
        <div className="weekly-status-container">
          <div className="d-flex flex-row align-items-center justify-content-between w-100 mb-3">
            <div>
              <span className="h6">Weekly Status</span>
            </div>
            <div className="d-flex flex-row align-items-center gap-2">
              <Icon path={mdiChevronLeft} size={1} />
              <span className="fw-semibold fs-6">10 Mar - 17 Mar</span>
              <Icon path={mdiChevronRight} size={1} />
            </div>
          </div>
          <div className="d-flex flex-row align-items-center justify-content-between w-100 mb-3">
            <div className="d-flex flex-column">
              <span className="text-muted">Scheduled Days</span>
              <h6>6</h6>
            </div>
            <div className="d-flex flex-column">
              <span className="text-muted">Worked Days</span>
              <h6>2</h6>
            </div>
          </div>
        </div>
        <Offcanvas
          isOpen={punchInOffcanvas}
          toggle={togglePunchInOffcanvas}
          direction="end"
          style={{ width: '40vw' }}
        >
          <ManualPunchIn setPunchInOffcanvas={setPunchInOffcanvas} />
        </Offcanvas>
      </CardBody>
    </Card>
  );
}

export default PunchInWidget;
